/**
 * Phase-1 go-live sectors for the RT split view.
 *
 * Internal users (cleartrip/flyin emails) get the split view on every sector; public
 * traffic only gets it on the sectors listed here. Each entry is BIDIRECTIONAL — the
 * reverse leg is derived, so add a route once.
 *
 * Remove this gate (and the sector check in `useGetSearchQueryURL`) once split view is
 * live for all sectors.
 */
const RT_SPLIT_VIEW_ENABLED_SECTORS: readonly (readonly [string, string])[] = [
    ['ruh', 'ahb'],
    ['dxb', 'trv'],
    ['cai', 'hrg'],
    ['dxb', 'del'],
    ['ahb', 'jed'],
    ['jed', 'dmm'],
    ['ruh', 'tzx'],
    ['auh', 'trv'],
    ['elq', 'cai'],
    ['dmm', 'med'],
    ['dxb', 'ccj'],
    ['shj', 'trz']

]

const buildSectorKey = (from: string, to: string) => `${from}-${to}`

const ENABLED_SECTOR_KEYS = new Set(
    RT_SPLIT_VIEW_ENABLED_SECTORS.flatMap(([from, to]) => [buildSectorKey(from, to), buildSectorKey(to, from)])
)

/** True when the searched sector is on the split-view rollout list (direction-agnostic). */
export const isRtSplitViewEnabledSector = (from?: string | null, to?: string | null): boolean => {
    if (!from || !to) return false
    return ENABLED_SECTOR_KEYS.has(buildSectorKey(from.trim().toLowerCase(), to.trim().toLowerCase()))
}
